import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils/index.js.mjs';

function SvgIcMap(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m10.04 4.653 3.987 1.409v13.427l-3.989-1.409.001-.031zm-1.5 13.316V4.578L4.75 6.061v13.39zm.587 1.38-4.172 1.632a1.25 1.25 0 0 1-1.705-1.165V5.55a.75.75 0 0 1 .477-.699L8.52 2.976a1.75 1.75 0 0 1 1.172-.036l5.122 1.81 4.234-1.638a1.25 1.25 0 0 1 1.701 1.166v13.928c0 .517-.318.98-.8 1.166l-4.534 1.753a1.75 1.75 0 0 1-1.166.034zm6.4-13.267v13.392l3.723-1.44V4.644z",
    clipRule: "evenodd"
  }));
}
var IcMap = createNolIcon(/*#__PURE__*/forwardRef(SvgIcMap));

export { IcMap as I };
